import { ACTIONS } from "../actions/dashboard-team";

const titleTable3 = {
    dot: true,
    text: 'セ・リーグ',
    background: 'green-dot',
    pl: 'pl-16 ',
};
const titleTable4 = {
    dot: true,
    text: 'パ・リーグ',
    background: 'blue-dot',
    pl: 'pl-16',
};
const titleTable5 = {
    dot: false,
    text: '交流戦',
    background: 'green-dot',
    pl: 'pl-16',
};

export default (state = { titleTable3, titleTable4, titleTable5 }, action) => {
    switch (action.type) {
        case ACTIONS.GET_ITEM_MONTH_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data.data,
            };
        case ACTIONS.GET_ITEM_MONTH_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};